var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    fill: "#fff",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm12.727 7.667c.7 0 1.273-.6 1.273-1.334C19 8.6 18.427 8 17.727 8s-1.273.6-1.273 1.333c0 .12.013.234.045.34l-2.259 2.374a1.074 1.074 0 0 0-.33-.047c-.116 0-.23.013-.332.047l-1.622-1.7c.031-.107.044-.227.044-.347 0-.733-.573-1.333-1.273-1.333s-1.272.6-1.272 1.333c0 .12.012.24.044.347L6.597 13.38a1.037 1.037 0 0 0-.324-.047c-.7 0-1.273.6-1.273 1.334C5 15.4 5.573 16 6.273 16s1.272-.6 1.272-1.333c0-.12-.012-.234-.044-.34l2.895-3.04c.102.033.217.046.331.046.115 0 .23-.013.331-.046l1.623 1.7a1.23 1.23 0 0 0-.045.346c0 .734.573 1.334 1.273 1.334s1.273-.6 1.273-1.334c0-.12-.013-.24-.045-.346l2.266-2.367c.102.033.21.047.324.047Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.75957084ecfcd2376ffc6ced91c3f096.svg";
export { ForwardRef as ReactComponent };